export function driverName(token, driverId) {
  const url = 'https://kindzadza2.apexhos.com/users';
  return fetch(url, {
    headers: {
      'authorization': token
    }
  })
  .then(response => response.json())
  .then(data => {
    let driverNamed;
    data.data.forEach(driver => {
      console.log(driver);
      if (driver._id === driverId) {
        driverNamed = `${driver.firstName} ${driver.lastName}`;
        localStorage.setItem('companyId', driver.companyId);
        document.getElementById('driverName').innerHTML = driverNamed;
      }
    });
    console.log(driverNamed);
    return driverNamed;
  });
}